import { RouteRecordRaw } from "vue-router";

export const mypage: RouteRecordRaw = {
  path: "/mypage",
  component: () =>
    import(/* webpackChunkName: "mypage" */ "@/layouts/Default.vue"),
  children: [
    {
      path: "",
      name: "Mypage",
      component: () =>
        import(/* webpackChunkName: "mypage" */ "@/views/mypage/Index.vue"),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "edit-phone-number",
      name: "EditPhoneNumber",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/EditPhoneNumber.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "reset-password",
      name: "ResetPassword",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/ResetPassword.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "set-worker-service",
      name: "SetWorkerService",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/SetWorkerService.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "registration-information-and-status",
      name: "RegistrationInformationAndStatus",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/RegistrationInformationAndStatus.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "personal-info",
      name: "MypagePersonalInfo",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/PersonalInfo.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "business-info",
      name: "MypageBusinessInfo",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/BusinessInfo.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "qualification-list",
      name: "MypageQualificationList",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/QualificationList.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "notification",
      name: "MypageNotification",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/accountInfo/notification/Index.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "subscribe-newsletter",
      name: "MypageSubscribeNewsletter",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/accountInfo/notification/SubscribeNewsletter.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "receive-push-notification",
      name: "MypageReceivePushNotification",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/accountInfo/notification/ReceivePushNotification.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "fav-list",
      name: "FavList",
      component: () =>
        import(/* webpackChunkName: "mypage" */ "@/views/mypage/FavList.vue"),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "mute-list",
      name: "MuteList",
      component: () =>
        import(/* webpackChunkName: "mypage" */ "@/views/mypage/MuteList.vue"),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "withholding",
      name: "Withholding",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/withholding/Index.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "withholding-slip-list/:year",
      name: "WithholdingSlipList",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/withholding/SlipList.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "salary",
      name: "Salary",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/salary/Index.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "salary/detail",
      name: "SalaryDetail",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/salary/Detail.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "set-bank",
      name: "SetBank",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/salary/SetBank.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "withdrawal",
      name: "Withdrawal",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/salary/Withdrawal.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "withdrawal-finished",
      name: "WithdrawalFinished",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/salary/WithdrawalFinished.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "rank",
      name: "Rank",
      component: () =>
        import(/* webpackChunkName: "mypage" */ "@/views/mypage/Rank.vue"),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "my-review",
      name: "MyReview",
      component: () =>
        import(/* webpackChunkName: "mypage" */ "@/views/mypage/MyReview.vue"),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "my-point",
      name: "MyPoint",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/myPoint/Index.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "point-history",
      name: "PointHistory",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/myPoint/PointHistory.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "refer-promotion",
      name: "ReferPromotion",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/referPromotion/Index.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "refer-promotion-register",
      name: "ReferPromotionRegister",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/referPromotion/Registration.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "exchange-coupon",
      name: "ExchangeCoupon",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/myPoint/ExchangeCoupon.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "confirm-exchange-coupon/:giftId",
      name: "ConfirmExchangeCoupon",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/myPoint/ConfirmExchangeCoupon.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "exchange-coupon-finished",
      name: "ExchangeCouponFinished",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/myPoint/ExchangeCouponFinished.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "account-info",
      name: "AccountInfo",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/accountInfo/Index.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "other-account-info",
      name: "OtherAccountInfo",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/accountInfo/otherAccountInfo/Index.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "leave-confirmation",
      name: "LeaveConfirmation",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/accountInfo/otherAccountInfo/leaveConfirmation/Index.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "leave-questionnaire",
      name: "LeaveQuestionnaire",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/accountInfo/otherAccountInfo/leaveConfirmation/questionnaire/Index.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "account",
      name: "MypageAccount",
      component: () =>
        import(/* webpackChunkName: "mypage" */ "@/views/mypage/Account.vue"),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "cancel-rate",
      name: "CancelRate",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/CancelRate.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "edit-emergency-contact-of-relationship",
      name: "EditEmergencyContactOfRelationship",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/EditEmergencyContactOfRelationship.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "watch-later-orders",
      name: "WatchLaterOrders",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/WatchLaterOrders.vue"
        )
    },
    {
      path: "education/training",
      name: "Training",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/education/training/Index.vue"
        )
    },
    {
      path: "desired-work-schedules",
      name: "DesiredWorkSchedules",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/DesiredWorkSchedule.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    }
  ]
};

/**
 * カメラ起動画面のみレイアウトが大きく変わるため、別ルーティングとしている
 */
export const cameraMypage: RouteRecordRaw = {
  path: "/mypage",
  component: () =>
    import(/* webpackChunkName: "applications" */ "@/layouts/Default.vue"),
  props: { isBackgroundTransparent: true },
  children: [
    {
      path: "edit-avatar",
      name: "MypageEditAvatar",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/EditAvatar.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "edit-id",
      name: "MypageEditId",
      component: () =>
        import(/* webpackChunkName: "mypage" */ "@/views/mypage/EditId.vue"),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "add-qualification",
      name: "MypageAddQualification",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/AddQualification.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "edit-qualification/:qualificationId",
      name: "MypageEditQualification",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/EditQualification.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "finish-signup",
      name: "MypageFinishSignup",
      component: () =>
        import(
          /* webpackChunkName: "mypage" */ "@/views/mypage/FinishSignup.vue"
        )
    }
  ]
};
